import { render, staticRenderFns } from "./SkillsDetailCard.vue?vue&type=template&id=fbd7a08a"
import script from "./SkillsDetailCard.vue?vue&type=script&lang=js"
export * from "./SkillsDetailCard.vue?vue&type=script&lang=js"
import style0 from "./SkillsDetailCard.vue?vue&type=style&index=0&id=fbd7a08a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports